// extracted by mini-css-extract-plugin
module.exports = {"tradeInput":"TradeInput-module--tradeInput--14Ju3","label":"TradeInput-module--label--3IJF3","buttonMax":"TradeInput-module--buttonMax--1l4TU"};